export default function isSelected(itemValue, selectedValue) {
	if (!selectedValue) {
		return false;
	}

	return selectedValue.value === itemValue.value;
}
